/**
 * goToClassicChannel action.
 */
import Channel from '../../classes/channel';
import ChannelUtils from '@shared/utils/channels';
import Focus from '@shared/types/enums/focus';
import Pages from '@pages';
import { pushRoute } from '../../store/thunks/route.thunk';
import { store } from '../../store/store';

/**
 * Function to redirect to the classic channel page.
 */
export default function goToClassicChannel(channel?: Channel) {
  const chIndex = ChannelUtils.findChannelPosition(channel?.id || '') || -1;
  store.dispatch(
    pushRoute({
      route: { Page: Pages.CLASSIC_CHANNEL },
      params: {
        current: {
          verticalIndex: chIndex + 1, // Keep in mind the filter rail, +1
          previousFocus: [
            Focus.RAILS_LIST,
            parseInt(Focus.RAILS_SUB_LIST + '' + (chIndex + 1)),
          ],
          channelId: channel?.id,
        },
        stack: {
          channel,
          stacked: true,
        },
        push: true,
      },
    })
  );
}
